import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FieldTypeConfig, FieldType, FormlyFieldProps } from '@ngx-formly/core';

interface MultiCheckboxProps extends FormlyFieldProps {
  formCheck: 'default' | 'inline' | 'switch' | 'inline-switch';
  class?: string;
}

@Component({
  standalone: false,
  selector: 'formly-field-button-checkbox-group',
  templateUrl: './button-checkbox-group.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldButtonCheckboxGroup extends FieldType<
  FieldTypeConfig<MultiCheckboxProps>
> {
  override defaultOptions = {
    props: {
      formCheck: 'default' as const,
      class: 'btn-outline-primary',
    },
  };

  get disabledControl() {
    return new FormControl({ value: this.formControl.value, disabled: true });
  }

  onChange(value: any, checked: boolean) {
    this.formControl.markAsDirty();
    if (this.props.type === 'array') {
      const currentValue = this.formControl.value || [];
      this.formControl.patchValue(
        checked
          ? currentValue.includes(value)
            ? currentValue
            : [...currentValue, value]
          : currentValue.filter((o) => o !== value)
      );
    } else {
      this.formControl.patchValue({
        ...this.formControl.value,
        [value]: checked,
      });
    }
    this.formControl.markAsTouched();
  }

  isChecked(option: any) {
    const value = this.formControl.value;

    return (
      value &&
      (this.props.type === 'array'
        ? value.indexOf(option.value) !== -1
        : value[option.value])
    );
  }
}
